export const SessionConst : {
    title: string;
    description: string;
} = 
    {
        title: '¿Deseas saber más del futuro?',
        description:'Compra una leída personalizada con Santa Zinos en video.',
    }
